import {
  styled,
  TableCell,
  tableCellClasses,
  TableRow,
  Tooltip,
} from "@mui/material";
import React from "react";
import { Branches } from "../../../models/supplierUserBarnch.model";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: "#F9FAFC",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
const deactiveUserStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: "400px",
  },
  maxHeight: "70vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  overflow: "auto",
  overflowX: "hidden",
  paddingRight: "3vh",
  paddingTop: "3vh",
  // direction: "ltr",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};
interface Props {
  branchs: Branches;
  handleBranchDelete: Function;
  handelBackgrundIcon: string;
}
const BranchesAccardionTableRows = ({
  branchs,
  handleBranchDelete,
  handelBackgrundIcon,
}: Props) => {
  return (
    <>
      <StyledTableRow className="nowrapClass">
        <StyledTableCell align="center" component="th" scope="row">
          <p
            style={{
              textAlign: "center",
              marginBottom: "-.5vh",
              color: "#1D4A87",
            }}
          >
            {branchs.branchTitle}
          </p>
        </StyledTableCell>
        <StyledTableCell align="center" component="th" scope="row">
          <p
            style={{
              textAlign: "center",
              marginBottom: "-.5vh",
              color: "#1D4A87",
            }}
          >
            {branchs.branchTypeTitle}
          </p>
        </StyledTableCell>
        <StyledTableCell align="center" component="th" scope="row">
          {branchs.isActiveTitle === "فعال" ? (
            <p
              style={{
                textAlign: "center",
                marginBottom: "-.5vh",
                color: "#28A745",
              }}
            >
              {branchs.isActiveTitle}
            </p>
          ) : (
            <p
              style={{
                textAlign: "center",
                marginBottom: "-.5vh",
                color: "#E6123D",
              }}
            >
              {branchs.isActiveTitle}
            </p>
          )}
        </StyledTableCell>

        <StyledTableCell align="center" component="th" scope="row">
          <p
            style={{
              textAlign: "center",
              marginBottom: "-.5vh",
              color: "#1D4A87",
            }}
          >
            {branchs.provinceAndCity}
          </p>
        </StyledTableCell>
        <StyledTableCell align="center" component="th" scope="row">
          <p
            style={{
              textAlign: "center",
              marginBottom: "-.5vh",
              color: "#1D4A87",
            }}
          >
            {branchs.phoneNumber}
          </p>
        </StyledTableCell>
        <StyledTableCell align="center" component="th" scope="row">
          <p
            style={{
              textAlign: "center",
              marginBottom: "-.5vh",
              color: "#1D4A87",
            }}
          >
            {branchs.ibanAndOwner}
          </p>
        </StyledTableCell>
        <StyledTableCell align="center" component="th" scope="row">
          <p
            style={{
              textAlign: "center",
              marginBottom: "-.5vh",
              color: "#1D4A87",
            }}
          >
            {branchs.address}
          </p>
        </StyledTableCell>
        {branchs.canBeDeleted ? (
          <StyledTableCell
            align="center"
            sx={{ borderTop: "none !important" }}
            className={handelBackgrundIcon}
          >
            <div
              style={{
                marginBottom: "-.5vh",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Tooltip title="حذف" arrow>
                <DeleteOutlineIcon
                  onClick={() => handleBranchDelete(branchs)}
                  style={{
                    color: "#1D4A87",
                    cursor: "pointer",
                    marginInline: "3px",
                  }}
                />
              </Tooltip>
            </div>
          </StyledTableCell>
        ) : (
          <StyledTableCell align="center" sx={{ borderTop: "none !important" }}>
            <div
              style={{
                marginBottom: "-.5vh",
                display: "flex",
                justifyContent: "center",
              }}
            ></div>
          </StyledTableCell>
        )}
      </StyledTableRow>
      {/* delete modal */}
    </>
  );
};

export default BranchesAccardionTableRows;
